export var WeekDayNumber;
(function (WeekDayNumber) {
    WeekDayNumber[WeekDayNumber["MONDAY"] = 1] = "MONDAY";
    WeekDayNumber[WeekDayNumber["TUESDAY"] = 2] = "TUESDAY";
    WeekDayNumber[WeekDayNumber["WEDNESDAY"] = 3] = "WEDNESDAY";
    WeekDayNumber[WeekDayNumber["THURSDAY"] = 4] = "THURSDAY";
    WeekDayNumber[WeekDayNumber["FRIDAY"] = 5] = "FRIDAY";
    WeekDayNumber[WeekDayNumber["SATURDAY"] = 6] = "SATURDAY";
    WeekDayNumber[WeekDayNumber["SUNDAY"] = 7] = "SUNDAY";
})(WeekDayNumber || (WeekDayNumber = {}));
//# sourceMappingURL=model.js.map